import axios from 'axios';
import { setSessionCookie } from './session';
import setting from './setting';

const auth = {
  isAuthenticated: false,
  authenticate(data, cb) {
    auth.isAuthenticated = true;
    console.log('submitLoginRequest data:', data);
    // const dataUrl = 'https://localhost:8443/api/BT001/101/1st%20Interim%20Analysis/outputs';
    // const dataUrl = 'http://localhost:8080/login_success.json';
    const dataUrl = `${setting.annotation_server}/login`;
    axios.post(dataUrl, data)
      .then(res => {
        console.log('login response:', res);
        cb(null, res);
      }, error => {
        cb(error, null);
      }
    );
  },
  signout(cb) {
    auth.isAuthenticated = false;
    setSessionCookie(null, {}, cb);
  }
};

export default auth;
